import { Form, InputGroup } from 'react-bootstrap'
import InputNumber from 'rc-input-number'
import { useTranslation } from 'react-i18next'

import { numbersOnly } from '../../../_services/common.service'

import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline'

import 'rc-input-number/assets/index.css'
import './InputNumberForPrePlan.scss'

const InputNumberComponentForPrePlan = ({
  dmode,
  min = 0,
  max = Number.MAX_SAFE_INTEGER,
  label,
  value,
  onValueChange,
  placeholder,
  name = '',
  style,
  labelStyle = '',
  dir = 'ltr',
  handleKeyPress,
  inputGroupWidth = '100%',
}) => {
  const { t } = useTranslation()

  const onlyNumbers = (value) => {
    return value.replace(/[^\d]/g, '') // Remove anything that is not a digit
  }

  return (
    <>
      <Form.Group dir={dir} style={{ width: '100%' }}>
        {label ? (
          <Form.Label className={`glo-label ${dmode ? 'glo-label-dark' : ''}`} style={labelStyle}>
            {typeof label === 'string' ? t(label) : label}
          </Form.Label>
        ) : (
          <Form.Label className={`glo-label ${dmode ? 'glo-label-dark' : ''}`} style={{ color: 'transparent' }}>
            *
          </Form.Label>
        )}
        <InputGroup style={{ width: inputGroupWidth }} dir={dir}>
          <InputNumber
            onKeyDown={(evt) =>
              evt.key === '.'
                ? evt.preventDefault()
                : evt.key === 'Enter'
                ? handleKeyPress(evt)
                : numbersOnly(evt, value, t('Character.results'))
            }
            dir={dir}
            min={min}
            max={max}
            parser={onlyNumbers}
            type="number"
            value={value}
            onChange={(val) => {
              onValueChange(val, name)
            }}
            style={{
              direction: dir === 'rtl' ? 'rtl' : 'ltr',
              textAlign: dir === 'rtl' ? 'right' : 'left',
              display: dir === 'rtl' ? 'flex' : '',
              flexDirection: dir === 'rtl' ? 'row-reverse' : '',
              ...style,
              width: '100%',
            }}
            className={`custom-input-number-pp ${
              dir === 'rtl' ? 'rtl-pp' : ''
            } ${dmode ? 'custom-input-number-dark-pp' : ''}`}
            upHandler={
              <div
                className={`custom-up-handler-pp ${
                  dmode ? 'custom-up-handler-dark-pp' : ''
                }`}
              >
                <ChevronUpIcon
                  style={{
                    width: 10,
                    height: 12,
                    color: dmode ? 'white' : '#4F4F4F',
                  }}
                />
              </div>
            }
            downHandler={
              <div
                className={`custom-down-handler-pp ${
                  dmode && 'custom-down-handler-dark-pp'
                }`}
              >
                <ChevronDownIcon
                  style={{
                    width: 10,
                    height: 12,
                    color: dmode ? 'white' : '#4F4F4F',
                  }}
                />
              </div>
            }
            placeholder={t(placeholder)}
            autoFocus={false}
          />
        </InputGroup>
      </Form.Group>
    </>
  )
}

export default InputNumberComponentForPrePlan